export function calculateBottomHalfBoundingBox(latLongs) {
  return [
    [Math.min(...latLongs.map((latLong) => latLong[0])), Math.min(...latLongs.map((latLong) => latLong[1]))],
    [Math.max(...latLongs.map((latLong) => latLong[0])), Math.max(...latLongs.map((latLong) => latLong[1]))],
  ]
}
